import { PrivateInterceptor } from "../../../../Base/interceptors/PrivateInterceptor";

// OBTENER PROVEEDORES PARA SCREEN
export const getCustomersDetails = async () => {
  const respuesta = await PrivateInterceptor(`Compras/CustomerDetails`, "GET");
  return respuesta;
};

export const getCustomersDetailsPorCustomer = async (IdCustomer) => {
  const respuesta = await PrivateInterceptor(`Compras/CustomerDetails/PorCustomer`, "POST", {IdCustomer});
  return respuesta;
};

// AGREGAR O EDITAR CUSTOMER
export const addCustomersDetails = async (data) => {
  const respuesta = await PrivateInterceptor(`Compras/CustomerDetails/add`, "POST", data);
  return respuesta;
};

export const cambiarCountry = async (IdCountry, Ids) => {
  const result = await PrivateInterceptor(`Compras/CustomerDetails/cambiarCountry`, 'POST', {IdCountry, Ids});
  return result;
}

export const cambiarEstadoCustomerD = async (IdStatus, Ids) => {
  const result = await PrivateInterceptor(`Compras/CustomerDetails/cambiarEstadoCustomerD`, 'POST', {IdStatus, Ids});
  return result;
}

export const GuardarCustomerDetails = async (Datos) => {
  const result = await  PrivateInterceptor(`Compras/CustomerDetails/GuardarCustomerDetails`, 'POST', {Datos});
  return result;
}

export const putChecksCustomerDetails = async (body) =>{
  const result = await PrivateInterceptor(`Compras/CustomerDetails/checkCustomerDetails`, 'PUT', body);
  return result;
}
